<template>
  <div class="login-container">
    <h2>协议请求配置系统</h2>
    <div class="form-container">
      <div class="tab">
        <button @click="isLogin = true" :class="{ active: isLogin }">登录</button>
        <button @click="isLogin = false" :class="{ active: !isLogin }">注册</button>
      </div>
      <form @submit.prevent="handleSubmit">
        <div class="form-item">
          <label>用户名</label>
          <input v-model="username" type="text" required placeholder="请输入用户名">
        </div>
        <div class="form-item">
          <label>密码</label>
          <input v-model="password" type="password" required placeholder="请输入密码">
        </div>
        <button type="submit" class="submit-btn">{{ isLogin ? '登录' : '注册' }}</button>
      </form>
    </div>
  </div>
</template>

<script>
import request from '@/api/request';

export default {
  name: 'Login',
  data() {
    return {
      isLogin: true,
      username: '',
      password: ''
    };
  },
  methods: {
    async handleSubmit() {
      try {
        if (this.isLogin) {
          // 登录：调用后端接口
          const res = await request.post('/login', {
            username: this.username,
            password: this.password
          });
          localStorage.setItem('token', res.token);
          this.$router.push('/config'); // 跳转到配置页
        } else {
          // 注册：调用后端接口
          const res = await request.post('/register', {
            username: this.username,
            password: this.password
          });
          alert(res.msg);
          this.isLogin = true; // 注册成功切换到登录页
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}
.form-container {
  width: 350px;
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
}
.tab {
  display: flex;
  margin-bottom: 20px;
}
.tab button {
  flex: 1;
  padding: 10px;
  border: none;
  background: #eee;
  cursor: pointer;
}
.tab button.active {
  background: #42b983;
  color: #fff;
}
.form-item {
  margin-bottom: 15px;
}
.form-item label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}
.form-item input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
.submit-btn {
  width: 100%;
  padding: 12px;
  border: none;
  background: #42b983;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}
.submit-btn:hover {
  background: #359469;
}
</style>